// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"951b27d5","668":"220e8fc9","838":"163f7b45"}[chunkId] + ".js";
};